// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTop_scrollToTop__y1tC2"};